export function langFromi18nLang(lang: string): "DE" | "FR" | "IT" {
    const up = lang.toUpperCase()
    if (up === "DE" || up === "FR" || up === "IT") {
        return up
    }
    return "DE"
}